<template>
<footer class="footer" id="contactUs" name="#contactUs">
    <div class="footerWrap clearfix">
        <div class="footerL clearfix">
            <dl>
                <dt>解决方案</dt>
                <dd><a href="#solution01" @click='setAnchor("/","solution01")'>全平台打通</a></dd>
                <dd><a href="#solution02" @click='setAnchor("/","solution02")'>聚合管理</a></dd>
                <dd><a href="#solution03" @click='setAnchor("/","solution03")'>安全风控</a></dd>
                <dd><a href="#solution04" @click='setAnchor("/","solution04")'>智能分析</a></dd>
            </dl>
            <dl>
                <dt>客户案例</dt>
                <dd><a href="#customerCase" @click='setAnchor("/","customerCase")'>珠宝类</a></dd>
                <dd><a href="#customerCase" @click='setAnchor("/","customerCase")'>女装类</a></dd>
                <dd><a href="#customerCase" @click='setAnchor("/","customerCase")'>药膳类</a></dd>
                <dd><a href="#customerCase" @click='setAnchor("/","customerCase")'>美妆类</a></dd>
                <dd><a href="#customerCase" @click='setAnchor("/","customerCase")'>健身类</a></dd>
                <dd><a href="#customerCase" @click='setAnchor("/","customerCase")'>茶叶类</a></dd>
            </dl>
            <dl>
                <dt>产品服务</dt>
                <dd><a href="#package" @click='setAnchor("/product","package")'>企业版</a></dd>
                <dd><a  href="#package" @click='setAnchor("/product","package")'>豪华版</a></dd>
                <dd><a  href="#package" @click='setAnchor("/product","package")'>至尊版</a></dd>
                <dd><a  href="#package" @click='setAnchor("/product","package")'>定制版</a></dd>
            </dl>
            <!-- <dl>
                <dt>逐鹿学堂</dt>
                <dd> <router-link to="/dynamic" tag="a">干货分享</router-link></dd>
                <dd><router-link to="/course" tag="a">使用大全</router-link></dd>
            </dl> -->
            <dl class="address">
                <dt>联系我们</dt>
                <!-- <dd>合作电话：‭18078847664‬</dd> -->
                <dd>售后电话：15890127200</dd>
                <!-- <dd>广州总部：广州市天河区长福路209号长兴智汇G座4A01</dd>
                <dd>上海分公司：上海市闵行区漕宝路勇卫商务大厦3楼351-1</dd>
                <dd>山东分公司：山东省济南市高新区新泺大街3003号5号楼2楼</dd> -->
                <dd>洛阳分公司：河南省洛阳市涧西区南昌路锦茂国际大厦1911</dd>
            </dl>
        </div>
        <div class="footerR">
            <div class="concern">关注终身客</div>
            <ul class="clearfix">
                <!-- <li>
                    <img src="../../assets/Images/customerCode.jpg" alt="客户经理">
                    <p>客户经理</p>
                </li> -->
                <li>
                    <img src="../../assets/Images/zsk-qrcode.jpg" alt="微信公众号">
                    <p>微信公众号</p>
                </li>
            </ul>
            <p class="AQ"><a href="https://beian.miit.gov.cn/" target="_blank"><img src="../../assets/Images/guohui.png" alt="国徽"/>ICP备案号：豫ICP备2022004718号</a></p>
        </div>
    </div>
</footer>
</template>

<script>
export default {
    name: "FooterComponent",
    methods: {
        setAnchor(path, selector) {
            sessionStorage.setItem("zhongshenkeanchor", selector)
            this.$router.push(path);
        }
    }

}
</script>

<style lang="scss" scoped>
.footer {
    height: 360px;
    background-color: #1e3046;
    position: relative;
}

.footerWrap {
    padding-top: 60px;
    color: #fafbfc;
    width: 1250px;
    margin: 0 auto;
}

.footerL {
    float: left;

    dl {
        float: left;
        margin-right: 40px;
        max-width: 215px;

        &.address {
            max-width: 450px;
            margin-right: 30px;
        }
    }

    dt {
        font-size: 19px;
        line-height: 36px;
        margin-bottom: 20px;
        font-weight: 500;
    }

    dd {
        font-size: 15px;
        line-height: 26px;
        color: #c9ced3;

        a:hover {
            color: #fff;
        }
    }
}

.footerR {
    float: right;
    padding: 0 20px;

    .concern {
        font-size: 19px;
        line-height: 36px;
        margin-bottom: 20px;
        font-weight: 500;
        text-align: center;

    }

    li {
        float:left;
        width: 220px;

        &>img {
            margin-left: 50px;
            width: 120px;
            height: 120px;
        }

        p {
            font-size: 13px;
            text-align: center;
            color: #fafbfc;
            line-height: 24px;
        }

    }

    li+li {
        margin-left: 25px;
    }
}

.AQ {
    text-align: center;
    color: #c9ced3;
    font-size: 13px;
    margin-top: 10px;

    &:hover a {
        color: #fff !important;
    }

    img {
        vertical-align: top;
        margin-right: 5px;
    }
}
</style>
